import _ from 'underscore';
import CourseElevations from 'collections/course/CourseElevations';
import CourseElevation from 'models/course/CourseElevation';

var GarminElevationService = function(args) {};

GarminElevationService.prototype.fetch = function fetch(options, context) {
    var courseElevations = new CourseElevations({ isFromImport: options.isFromImport }),
        courseElevation = null;

    _.each(options.geoPoints, function(p) {
        _.each(p.points, function(point) {
            point.elevation = null; // set a default value
            if (point.lat && point.lng) {
                courseElevation = new CourseElevation({
                    latitude: point.lat,
                    longitude: point.lng
                });
                courseElevations.add(courseElevation);
            }
        });
    });

    courseElevations.fetch({
        success: function() {
            if (options.success) {
                _.each(options.geoPoints, function(p) {
                    _.each(p.points, function(point) {
                        point.elevation = courseElevations.getElevationByLatLng(point.lat, point.lng);
                    });
                });
                options.success.call(context, options.geoPoints);
            }
        },
        error: function(jqXHR, status, errorThrown) {
            if (options.error) {
                options.error.call(context, errorThrown, status);
            }
        }
    });
};

export default GarminElevationService;
